<div *ngIf="isVisible" class="relative z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!-- Background backdrop -->
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm transition-opacity"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <!-- Modal panel -->
      <div class="relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">

        <form [formGroup]="contactForm" (ngSubmit)="saveContact()">

          <!-- Close button -->
          <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
            <button type="button" (click)="closeModal()" class="rounded-md bg-white text-gray-400 hover:opacity-90 focus:outline-none">
              <span class="sr-only">Close</span>
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div class="px-4 py-4 lg:px-6 lg:py-6">
            <h3 class="text-2xl font-semibold text-gray-900 mb-6" id="modal-title">
              {{ mode === 'edit' ? 'Edit Contact' : 'Create New Contact' }}
            </h3>

            <div class="space-y-4">
              <!-- Name and Surname -->
              <div class="grid grid-cols-2 gap-4">
                <!-- Name -->
                <fieldset [disabled]="loading">
                  <label for="name" class="block text-sm font-medium leading-6 text-gray-900">
                    <span class="text-red-500 mr-1">*</span>Name
                  </label>
                  <div class="mt-2">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      formControlName="name"
                      placeholder="Enter name"
                      class="block w-full rounded-md border-0 py-1.5 pl-3 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm/6"
                    />
                  </div>
                  <div class="pt-1" *ngIf="contactForm.get('name')?.touched && contactForm.get('name')?.invalid">
                    <div class="text-xs text-red-500" *ngIf="contactForm.get('name')?.errors?.['required']">
                      Name is required.
                    </div>
                  </div>
                </fieldset>

                <!-- Surname -->
                <fieldset [disabled]="loading">
                  <label for="surname" class="block text-sm font-medium leading-6 text-gray-900">
                    <span class="text-red-500 mr-1">*</span>Surname
                  </label>
                  <div class="mt-2">
                    <input
                      type="text"
                      id="surname"
                      name="surname"
                      formControlName="surname"
                      placeholder="Enter surname"
                      class="block w-full rounded-md border-0 py-1.5 pl-3 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm/6"
                    />
                  </div>
                  <div class="pt-1" *ngIf="contactForm.get('surname')?.touched && contactForm.get('surname')?.invalid">
                    <div class="text-xs text-red-500" *ngIf="contactForm.get('surname')?.errors?.['required']">
                      Surname is required.
                    </div>
                  </div>
                </fieldset>
              </div>

              <!-- Email Address -->
              <fieldset [disabled]="loading">
                <label for="email" class="block text-sm font-medium leading-6 text-gray-900">
                  <span class="text-red-500 mr-1">*</span>Email Address
                </label>
                <div class="mt-2">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    formControlName="email"
                    placeholder="Enter email address"
                    class="block w-full rounded-md border-0 py-1.5 pl-3 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm/6"
                  />
                </div>
                <div class="pt-1" *ngIf="contactForm.get('email')?.touched && contactForm.get('email')?.invalid">
                  <div class="text-xs text-red-500" *ngIf="contactForm.get('email')?.errors?.['required']">
                    Email Address is required.
                  </div>
                  <div class="text-xs text-red-500" *ngIf="contactForm.get('email')?.errors?.['pattern']">
                    Please enter a valid email address (e.g., user&#64;example.com).
                  </div>
                </div>
              </fieldset>

              <!-- Phone Number and Lead Source -->
              <div class="grid grid-cols-2 gap-4">
                <!-- Phone Number -->
                <fieldset [disabled]="loading">
                  <label for="phone_number" class="block text-sm font-medium leading-6 text-gray-900">
                    Phone Number
                  </label>
                  <div class="mt-2">
                    <input
                      type="tel"
                      id="phone_number"
                      name="phone_number"
                      formControlName="phone_number"
                      placeholder="Enter phone number"
                      class="block w-full rounded-md border-0 py-1.5 pl-3 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm/6"
                    />
                  </div>
                  <div class="pt-1" *ngIf="contactForm.get('phone_number')?.touched && contactForm.get('phone_number')?.invalid">
                    <div class="text-xs text-red-500" *ngIf="contactForm.get('phone_number')?.errors?.['pattern']">
                      Please enter a valid phone number (e.g., +1-555-123-4567).
                    </div>
                  </div>
                </fieldset>

                <!-- Lead Source -->
                <fieldset [disabled]="loading">
                  <label for="lead_source" class="block text-sm font-medium leading-6 text-gray-900">
                    Lead Source
                  </label>
                  <div class="mt-2">
                    <select
                      id="lead_source"
                      name="lead_source"
                      formControlName="lead_source"
                      class="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primary sm:text-sm/6"
                    >
                      <option value="">Select source</option>
                      <option *ngFor="let source of leadSources" [value]="source">
                        {{ source }}
                      </option>
                    </select>
                  </div>
                </fieldset>
              </div>

              <!-- Job Title -->
              <fieldset [disabled]="loading">
                <label for="job_title" class="block text-sm font-medium leading-6 text-gray-900">
                  Job Title
                </label>
                <div class="mt-2">
                  <input
                    type="text"
                    id="job_title"
                    name="job_title"
                    formControlName="job_title"
                    placeholder="Enter job title"
                    class="block w-full rounded-md border-0 py-1.5 pl-3 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm/6"
                  />
                </div>
              </fieldset>

              <!-- LinkedIn -->
              <fieldset [disabled]="loading">
                <label for="linkedin" class="block text-sm font-medium leading-6 text-gray-900">
                  LinkedIn
                </label>
                <div class="mt-2">
                  <input
                    type="url"
                    id="linkedin"
                    name="linkedin"
                    formControlName="linkedin"
                    placeholder="https://linkedin.com/in/username"
                    class="block w-full rounded-md border-0 py-1.5 pl-3 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm/6"
                  />
                </div>
                <div class="pt-1" *ngIf="contactForm.get('linkedin')?.touched && contactForm.get('linkedin')?.invalid">
                  <div class="text-xs text-red-500" *ngIf="contactForm.get('linkedin')?.errors?.['pattern']">
                    Please enter a valid LinkedIn URL.
                  </div>
                </div>
              </fieldset>

              <!-- Personal Background -->
              <fieldset [disabled]="loading">
                <label for="personal_background" class="block text-sm font-medium leading-6 text-gray-900">
                  Personal Background
                </label>
                <div class="mt-2">
                  <textarea
                    id="personal_background"
                    name="personal_background"
                    formControlName="personal_background"
                    rows="3"
                    placeholder="Enter personal background"
                    class="block w-full rounded-md border-0 py-1.5 pl-3 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm/6"
                  ></textarea>
                </div>
              </fieldset>

              <!-- Existing Companies (Edit Mode Only) -->
              <div *ngIf="mode === 'edit' && existingCompanies.length > 0">
                <label class="block text-sm font-medium leading-6 text-gray-900 mb-2">
                  Existing Companies
                </label>
                <div class="space-y-2">
                  <div *ngFor="let companyContact of existingCompanies"
                       class="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div class="flex items-center space-x-3">
                      <div class="size-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                        <span class="text-primary text-sm font-medium">
                          {{ (companyContact.company?.name?.charAt(0) || '?').toUpperCase() }}
                        </span>
                      </div>
                      <div>
                        <p class="text-sm font-medium text-gray-900">{{ companyContact.company?.name || 'Unknown Company' }}</p>
                        <p class="text-xs text-gray-500" *ngIf="companyContact.is_default === 1">Primary Company</p>
                      </div>
                    </div>
                    <button
                      type="button"
                      (click)="removeCompany(companyContact.id)"
                      class="p-2 text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
                      title="Remove company">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
                        <path fill-rule="evenodd" d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z" clip-rule="evenodd" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Add Company (Always shown, but label changes based on mode) -->
              <fieldset [disabled]="loading">
                <label for="company_id" class="block text-sm font-medium leading-6 text-gray-900">
                  {{ mode === 'edit' ? 'Add Another Company' : 'Select Company' }}
                </label>
                <div class="mt-2">
                  <select
                    id="company_id"
                    name="company_id"
                    formControlName="company_id"
                    class="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primary sm:text-sm/6"
                  >
                    <option value="">Select company</option>
                    <option *ngFor="let company of companies" [value]="company.id">
                      {{ company.name }}
                    </option>
                  </select>
                </div>
              </fieldset>

            </div>
          </div>

          <!-- Action buttons -->
          <div class="px-4 sm:px-6 pb-6 grid grid-cols-2 gap-4">
            <button
              type="button"
              (click)="closeModal()"
              [disabled]="loading"
              class="w-full rounded-md px-4 py-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed">
              Cancel
            </button>
            <button
              type="submit"
              [disabled]="loading"
              class="w-full rounded-md px-4 py-3 text-sm font-medium text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed">
              <span *ngIf="!loading">{{ mode === 'edit' ? 'Update Contact' : 'Save Contact' }}</span>
              <span *ngIf="loading" class="flex items-center justify-center">
                <svg class="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                {{ mode === 'edit' ? 'Updating...' : 'Saving...' }}
              </span>
            </button>
          </div>

        </form>

      </div>
    </div>
  </div>
</div>
